



















































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import { required } from 'vuelidate/lib/validators';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { MSSPMonthyManaged } from '../../types';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { FwProductObjectType, CasbAppList, ProductFlavourRegion } from '@/modules/msw-tenant-management/types';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir/tooltip.dir';
import { SwTable, TableColumnConfig, TableEntryGroup } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
// import  AddProductModal  from '@/shared/add-product/add-product-modal.vue';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { InfoState } from '@/core';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
const cssPrefix = 'confirmMsspMonthly';

@Component({
  components: {
    ...UUIFComponent,
    SwDatetimePicker,
    SwForm,
    SwFormRow,
    SwTextfield,
    SwFormRowError,
    SwCheckbox,
    SwIcon,
    SwIconButton,
    SwTable,
    // AddProductModal,
    // TzNSAProduct,
  },
  validations: {
    msspMonthyManaged: {
      nodeCount: { required },
      expiryDate: { required },
      serviceId: { required },
      regionId: { },
      applicationName: { },
    },
  },
})

export default class MsspMonthlyManagedDialog extends SwExtendedVue {
  isHA: boolean = false;
  // @Mutation
  // setNewProductModalObject: VuexMappedMutation<SetNewProductModalObjectPayload>;
  // @Mutation
  // setAnotherProductModalObject: VuexMappedMutation<SetAnotherProductModalObjectPayload>;
  cssPrefix = cssPrefix;
  @Prop()
  message: string;
  @Prop()
  serialNumber: string;
  @Prop()
  showMSSPMonthyManged: boolean;
  @Prop()
  showMSSPNodeCount: string;
  @Prop()
  groupId: any;
  @Prop()
  pId: any;
  @Prop()
  prodId: any;
  @Prop()
  isMSSPFirewallProduct: boolean;
  @Prop()
  isSecaasProduct: boolean;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  productOptions: SelectOption[] = [];
  tzserviceOptions: SelectOption[] = [];
  regionOptions: SelectOption[] = [];
  singlePickerConfigService: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.pickDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick,
    selectableDatesRange: { startDate: String(new Date().getMonth() + 1)
    .concat('/', String(new Date().getDate() + 1) , '/', String(new Date().getFullYear())) },
    hidePreAndNextMonthDates: true,
  };
  singlePickerConfigChild: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.pickDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClickChild,
    selectableDatesRange: { startDate: String(new Date().getMonth() + 1)
    .concat('/', String(new Date().getDate() + 1) , '/', String(new Date().getFullYear())) },
    hidePreAndNextMonthDates: true,
  };
  firewallOptions: SelectOption[] = [];
  childServiceOptions: SelectOption[] = [];
  regionOprtions: SelectOption[] = [];
  manageOptions: SelectOption[] = [{
    id: 'cloud',
    label: 'Cloud',
    value: 'cloud',
  }];
  selectedService: any = [];
  serviceDetails: any = {};
  showZt: boolean = false;
  showExpiry: boolean = false;
  showChildExpiry: boolean = false;
  showDc: boolean = false;
  msspAppliances: any = {};
  currentServices: string = '';
  applicationOption: SelectOption[] = [];
  serviceLabel:string = '';
  childServiceLabel: string = '';
  sslServiceLabel: string = '';
  applicableServices: any = [];
  isGen8: boolean = false;
  serviceChange:boolean = false;
  showRegion:boolean = false;
  appShowZt: boolean = false;
  ztValue: boolean = false;
  isDCApplies: boolean = false;
  todaysDate: string = '';
  orgIdText:string = '';
  minCount: any = 0;
  maxCount: any = 0;
  childMinCount: any = 0;
  childMaxCount: any = 0;
  infoIconText: string = '';
  applianceText: string = '';
  serviceShowUpperLimit: string = '';
  childShowUpperLimit:  string = '';
  fwProductObject: any = {
    firewall: '',
    productName: '',
    serviceName: '',
    childServiceName: '',
    unitSelected: 'setUpperLimit',
    childUnitSelected: 'setUpperLimit',
    ShowUpperLimit: false,
    ShowChildUpperLimit: false,
    upperLimit: '',
    childUpperLimit: '',
    dateSelected: '',
    expiryType: 'Never',
    childExpiryType: 'Never',
    regionSelected: '',
    childDateSelected: '',
    productId: '',
    applicationName: '',
    friendlyName: '',
    showFriendlyName: 'NO',
    showUnits: false,
    regionName: '',
    showRegion: false,
    showZt: false,
    dataCenter: '',
    manage: 'cloud',
    dcName: '',
  };
  fwRequest: FwProductObjectType = {
    productGroupId: '',
    Mode:'ENROLL',
    ProductID: '',
    serialNumber: '',
    serviceId: '',
    nodeCount: '1',
    subDomain: '',
    expirationDate: '',
    regionName: '',
    regionID: '',
    friendlyName: '',
    validationMessage: '',
    isZT: 'NO',
    isHA: 'NO',
    Services: [{
      serviceId: '',
      nodeCount: '1',
      expirationDate: '',
    }, {
      serviceId: '',
      nodeCount: '1',
      expirationDate: '',
    }],
  };
  dateSelected: string = '';
  childDateSelected: string = '';
  getShowErrMsg:boolean = false;
  showAgree: boolean = false;
  isDisabled: boolean = false;
  serviceTooltip: string = '';
  serviceData: TableEntryGroup[] = [];
  isReadOnly: boolean = false;
  showMgmtOpt: boolean = false;
  acceptProvision:boolean = false;
  showUnits: string = '';
  msspMonthyManaged: MSSPMonthyManaged = {
    unitSelected: 'setUpperLimit',
    nodeCount : '',
    expiryDate : '',
    serviceId : '',
    regionId: '',
    showApplicationOption: false,
    OganizationIDValue: '',
    friendlyNameBaseText: '',
    applicationName: '',
    showSubDomainName: false,
    showOrganizationId: false,
    subDomain: '',
    friendlyName: '',
    showFriendlyName: '',
    regionName: '',
  };
  editFriendName: boolean = false;
  fName: string = '';
  platform: string = '';
  disableRegionSelect: boolean = false;
  productName: string = '';
  disableServiceChange: boolean = true;
  showLicenceCheckbox: boolean = false;
  getExistingAppliances: boolean = false;
  isMdr: boolean = false;
  showHA: boolean = false;
  get epssTooltip(): TooltipDirValues {
    return {
      enabled: this.isDisabled,
      placement: 'top',
      content: this.serviceTooltip,
      compact: true,
    };
  }
  get nodeCountTooltip(): TooltipDirValues {
    return {
      enabled: this.sslVpnObject.tooltip !== '',
      placement: 'top',
      content: this.sslVpnObject.tooltip,
      compact: true,
    };
  }
  onDataCenterSelected() {
    const reg: any = this.regionOptions.filter(obj => obj.id === this.fwProductObject.dataCenter)[0];
    this.fwRequest.regionName = reg.value;
    this.fwRequest.regionID = this.fwProductObject.dataCenter;
  }
  onDayClick() {
    this.fwProductObject.expiryType = 'selectExpiry';
    // this.fwProductObject.expiryType = this.fwProductObject.dateSelected === '' ? 'Never' : 'selectExpiry';
    this.fwRequest.Services[0].expirationDate = this.fwProductObject.expiryType !== 'Never' || this.fwProductObject.expiryType !== ''  ? this.fwProductObject.dateSelected : 'Never';
  }
  onDayClickChild() {
    this.fwProductObject.childExpiryType = 'selectExpiry';
    // this.fwProductObject.childExpiryType = this.fwProductObject.childDateSelected === '' ? 'Never' : 'selectExpiry';
    this.fwRequest.Services[1].expirationDate = this.fwProductObject.childExpiryType !== 'Never' || this.fwProductObject.childExpiryType !== '' ? this.fwProductObject.childDateSelected : 'Never';
  }
  getTodaysDate() {
    const today = new Date();
    const dd = String(today.getDate())
    .padStart(2, '0') + 1;
    const mm = String(today.getMonth() + 1)
              .padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    // console.warn(mm + '/' + dd + '/' + yyyy);
    return `${mm}/${dd}/${yyyy}`;
  }

  dateRange = {
    startDate: this.getTodaysDate(),
    endDate: '',
  };

  get serviceOptions(): SelectOption[] {
    const services:any[] = this.serviceDetails?.Services || [];
    const serviceOptions:any = [];
    services.forEach((ele:any) => ele.isProvisioningService === 'YES' ? serviceOptions.push({ id: ele.ServiceID, label: ele.ServiceName, value: ele.ServiceID }) : '');
    return serviceOptions || [];
  }

  get regionIdOptions(): SelectOption[] {
    const regions:any[]  = this.serviceDetails?.Regions;
    const dcOptions:any = [];
    regions.forEach((ele:any) => dcOptions.push({ id: ele.RegionID, label: ele.RegionName, value: ele.RegionID }));
    return dcOptions || [];
  }

  onDayClick2() {
    // @ts-ignore
    this.$refs.dateTimePicker.outsidePopover = true;
    // @ts-ignore
    this.$refs.dateTimePicker.$emit('input', this.msspMonthyManaged.expiryDate);
  }
  onDayClickSsl () {
    this.sslVpnObject.expiryType = 'selectExpiry';
    // this.sslVpnObject.dateSelected = this.fwProductObject.childDateSelected !== '' ? this.fwProductObject.childDateSelected : this.childDateSelected;
    // this.fwRequest.Services[2].expirationDate = this.sslVpnObject.dateSelected;
    if (!this.showAgree) {
      this.onClickAccept();
    }
    // @ts-ignore
    this.$refs.expiryDateChild.outsidePopover = true;
    // @ts-ignore
    this.$refs.expiryDateChild.$emit('input', this.sslVpnObject.dateSelected);
  }
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: ('Select Date'), // Showing inapproprte value so just hardcoding it.Will take care later
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick2,
    selectableDatesRange: this.dateRange,
    hidePreAndNextMonthDates: true,
  };
  sslPickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.pickDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClickSsl,
    selectableDatesRange: { startDate: (this.todaysDate.slice(4, 6)).concat('/', this.todaysDate.slice(6) + 1, '/', this.todaysDate.slice(0, 4)) },
    hidePreAndNextMonthDates: true,
  };
  sslVpnObject: any = {
    serviceId: '',
    showExpiry:false,
    showNodeCount: false,
    sslVpnToggle: false,
    nodeCount: '0',
    totalNodeCount: '0',
    maxNodeCount: '0',
    expiryType: 'Never',
    dateSelected: '',
  };
  unitSelected = 'setUpperLimit';
  expiryType = 'Never';
  showUpperLimit:string = 'FALSE';
  onChangeLimit() {
  }
  closeDialog() {
    this.$emit('closeMSSPMonthlyDialog', false);
  }
  sslVpnChange() {
    // this.fwRequest.Services.push({
    //   serviceId: this.sslVpnObject.serviceId,
    //   nodeCount: this.sslVpnObject.nodeCount,
    //   expirationDate: this.sslVpnObject.expiryType === 'selectExpiry' ? this.sslVpnObject.dateSelected : 'Never',
    // });
  }
  get getNodeCountErr() {
    let res: boolean = false;
    if (this.sslVpnObject.sslVpnToggle
    && this.getShowErrMsg && Number(this.sslVpnObject.nodeCount) <= 0) {
      res = true;
    } else if (this.sslVpnObject.sslVpnToggle
    && this.getShowErrMsg
    && Number(this.sslVpnObject.nodeCount) + Number(this.sslVpnObject.totalNodeCount) > Number(this.sslVpnObject.maxNodeCount)) {
      res = true;
    } else {
      res = false;
    }
    return res;
  }
  get checkForDate() {
    let res: boolean = false;
    if (this.getShowErrMsg
    && this.sslVpnObject.expiryType === 'selectExpiry'
    && this.sslVpnObject.dateSelected === '') {
      res = true;
    } else {
      res = false;
    }
    return res;
  }
  onChangeSSL() {
    console.warn(this.sslVpnObject.sslVpnToggle);
    if (!this.sslVpnObject.sslVpnToggle) {
      this.sslVpnObject.expiryType = 'Never';
      this.sslVpnObject.dateSelected = '';
      this.sslVpnObject.nodeCount = '0';
    }
  }
  onChangeSslExpiry() {
    this.sslVpnObject.dateSelected = this.sslVpnObject.expiryType === 'Never' ? '' : this.sslVpnObject.dateSelected;
    // this.fwRequest.Services[2].expirationDate = this.sslVpnObject.dateSelected === '' && this.sslVpnObject.expiryType === 'Never' ? 'Never' : this.sslVpnObject.dateSelected;
    if (!this.showAgree) {
      this.onClickAccept();
    }
  }
  onChangeLimits() {
    this.fwProductObject.upperLimit = this.fwProductObject.unitSelected === 'noUpperLimit' ? '99999' : '';
    this.updateNodeCount();
  }
  onChangeChildLimit() {
    this.fwProductObject.childUpperLimit = this.fwProductObject.childUnitSelected === 'noUpperLimit' ? '99999' : '';
    this.updateChildNodeCount();
  }
  updateNodeCount() {
    this.fwRequest.Services[0].nodeCount =  this.fwProductObject.upperLimit;
  }
  updateChildNodeCount() {
    this.fwRequest.Services[1].nodeCount = this.fwProductObject.childUpperLimit;
  }
  get checkUpperLimit() {
    if (this.fwProductObject.upperLimit === '') {
      return this.$t('tenantMgmt.provision.validations.upperLimitReq');
    }
    if (Number(this.fwProductObject.upperLimit) < this.minCount || Number(this.fwProductObject.upperLimit) > this.maxCount) {
      return String(this.$t('tenantMgmt.provision.validations.validRange'))
      .concat(this.minCount, String(this.$t('tenantMgmt.provision.validations.and')), this.maxCount);
    }
  }
  get checkChildUpperLimit() {
    if (this.fwProductObject.childUpperLimit === '') {
      return this.$t('tenantMgmt.provision.validations.upperLimitReq');
    }
    if (Number(this.fwProductObject.childUpperLimit) < this.childMinCount || Number(this.fwProductObject.childUpperLimit) > this.childMaxCount) {
      return String(this.$t('tenantMgmt.provision.validations.validRange'))
      .concat(this.childMinCount, String(this.$t('tenantMgmt.provision.validations.and')), this.childMaxCount);
    }
  }
  onClickSubmit() {
    this.getShowErrMsg = true;
    this.$store.commit('TenantManagementStoreModule/setNewProductObjectFurtherValidation', { performFurtherValidation: true });
    if (this.expiryType === 'Never') {
      this.msspMonthyManaged.expiryDate = 'Never';
    }
    if (this.msspMonthyManaged.showOrganizationId) {
      this.fwRequest.regionName = this.msspMonthyManaged.regionName;
      this.fwRequest.subDomain = this.msspMonthyManaged.subDomain;
      this.fwRequest.friendlyName = this.msspMonthyManaged.friendlyName;
    }
    if (this.prodId === '-7' || this.prodId === '-8' || this.prodId === '-21') {
      this.fwRequest.regionName = this.msspMonthyManaged.regionName;
      this.fwRequest.regionID = this.msspMonthyManaged.regionId;
      this.fwRequest.Services.splice(1, 1);
    }
    // if selected Security Services Bundle is Essential Protection Service Suite then show confirmation else proceed
    if (this.checkInputValidation() && this.msspAppliances?.serviceIDsToValidate?.split(',')?.includes(this.fwProductObject?.serviceName)) {
      confirmService.confirm({
        status: 'major',
        message: this.msspAppliances?.ValidationMessage,
        buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.confirm')), isDefault: true }],
      })
      .then((isConfirmed : any) => {
        if (isConfirmed === 'ok') {
          this.goToNextStep();
        }
      });
    } else {
      this.goToNextStep();
    }
  }

  goToNextStep() {
    if (this.getExistingAppliances && this.checkInputValidation()) {
      try {
        this.$store.commit('startLoading');
        if (this.sslVpnObject.sslVpnToggle) {
          this.fwRequest.Services.push({
            expirationDate: this.sslVpnObject.dateSelected !== '' ? this.sslVpnObject.dateSelected : 'Never',
            nodeCount: this.sslVpnObject.nodeCount,
            serviceId: this.sslVpnObject.serviceId,
          });
        }
        return new Promise((res: any, rej: any) => {
          this.$store.dispatch('MswProductsStoreModule/editProductProvision', this.fwRequest)
          .then((resp: any) => {
            if (resp.operationStatus === 'NOK') {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
              // this.$emit('closeMSSPMonthlyDialog');
              rej(resp);
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
              this.$emit('closeMSSPMonthlyDialog', true);
              res(resp);
            }
            this.$store.commit('stopLoading');
          });
        });
      } catch {
        this.$store.commit('stopLoading');
        // this.$emit('closeProductModal');
      }
    }
    if (this.checkInputValidation()) {
      if (this.showUnits === 'YES') {
        const enrollDerollMssp: any = {
          serialNumber: this.serialNumber,
          Mode: 'ENROLL',
          expirationDate: this.msspMonthyManaged.expiryDate,
          isForcedEnrollValidation: 'true',
          serviceId: parseInt(this.msspMonthyManaged.serviceId, 10) || 0,
          regionID: parseInt(this.msspMonthyManaged.regionId, 10) || 0,
          ProductID: this.pId || '',
        };
        if (this.msspMonthyManaged.unitSelected === 'setUpperLimit') {
          enrollDerollMssp['nodeCount'] = this.msspMonthyManaged.nodeCount || '1';
        } else if (this.msspMonthyManaged.unitSelected === 'noUpperLimit') {
          enrollDerollMssp['nodeCount'] = '99999';
        }
        if (this.expiryType === 'selectExpiry') {
          enrollDerollMssp['expirationDate'] = this.msspMonthyManaged.expiryDate;
        }
        if (this.msspMonthyManaged.showApplicationOption) {
          enrollDerollMssp['applicationId'] = this.msspMonthyManaged.applicationName;
        }
        if (this.msspMonthyManaged.showSubDomainName) {
          enrollDerollMssp['subdomain'] = this.msspMonthyManaged.subDomain;
          enrollDerollMssp['friendlyName'] = this.msspMonthyManaged.subDomain;
        }
        if (this.msspMonthyManaged.showFriendlyName === 'YES' || this.msspMonthyManaged.showFriendlyName === 'READONLY') {
          enrollDerollMssp['friendlyName'] = this.msspMonthyManaged.friendlyName;
        }
        console.warn(enrollDerollMssp);
        this.$store.dispatch('MswProductsStoreModule/editProductProvision', enrollDerollMssp)
        .then((response: any) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
            this.$emit('closeMSSPMonthlyDialog', true);
          } else if (response.msgCode === 'MSWAPP:NONMSSPTENANTENROLLMSG') {
            this.$store.commit('enqueueMessage', { infoType: 'informational', infoMsg: response.msgDesc });
            // this.$emit('closeMSSPMonthlyDialog');Tenant Name

          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
          }
        })
        .catch(() => {
          this.$store.commit('stopLoading');
        });
      }
      if (this.showUnits === 'NO') {
        const enrollDerollMssp: any = {
          serialNumber: this.serialNumber,
          Mode: 'ENROLL',
          nodeCount: '1',
          expirationDate: this.msspMonthyManaged.expiryDate,
          isForcedEnrollValidation: 'true',
          serviceId: parseInt(this.msspMonthyManaged.serviceId, 10) || 0,
          regionID: parseInt(this.msspMonthyManaged.regionId, 10) || 0,
          ProductID: this.pId || '',
        };
        if (this.expiryType === 'selectExpiry') {
          enrollDerollMssp['expirationDate'] = this.msspMonthyManaged.expiryDate;
        }
        if (this.msspMonthyManaged.showApplicationOption) {
          enrollDerollMssp['applicationId'] = this.msspMonthyManaged.applicationName;
        }
        if (this.msspMonthyManaged.showSubDomainName) {
          enrollDerollMssp['subdomain'] = this.msspMonthyManaged.subDomain;
          enrollDerollMssp['friendlyName'] = this.msspMonthyManaged.subDomain;
        }
        if (this.msspMonthyManaged.showFriendlyName === 'YES' || this.msspMonthyManaged.showFriendlyName === 'READONLY') {
          enrollDerollMssp['friendlyName'] = this.msspMonthyManaged.friendlyName;
        }
        console.warn(enrollDerollMssp);
        this.$store.dispatch('MswProductsStoreModule/enrollDerollMssp', enrollDerollMssp)
        .then((response: any) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
            this.$emit('closeMSSPMonthlyDialog', true);
          } else if (response.msgCode === 'MSWAPP:NONMSSPTENANTENROLLMSG') {
            this.$store.commit('enqueueMessage', { infoType: 'informational', infoMsg: response.msgDesc });
            // this.$emit('closeMSSPMonthlyDialog');
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
          }
        })
        .catch(() => {
          this.$store.commit('stopLoading');
        });
      }
    }
  }

  onChangeExpiry(val:any) {
    console.warn(val);
    this.msspMonthyManaged.expiryDate = '';
  }

  checkInputValidation(): boolean {
    this.$v.msspMonthyManaged!.$touch();
    // console.warn(this.$v!.msspMonthyManaged!.nodeCount!.$dirty);
    // console.warn(this.$v!.msspMonthyManaged!.nodeCount!.$dirty);
    // console.warn('fright', this.fwRequest.serialNumber === '' , this.fwRequest.serialNumber === 'register');
    // console.warn('s', this.fwRequest.Services[0].serviceId === '' , this.fwRequest.Services[1].serviceId === '');
    // console.warn('s1', !this.showExpiry || this.fwRequest.Services[0].expirationDate === '' , !this.showChildExpiry ||  this.fwRequest.Services[1].expirationDate === '');
    // console.warn('s2', this.fwRequest.regionName === '' && this.fwRequest.regionID === '');
    if (this. prodId === '-7' || this.prodId === '-8' || this.prodId === '-21') {
      if (this.fwRequest.serialNumber !== '' && this.fwRequest.Services[0].serviceId !== '' &&
          (!this.showExpiry || this.fwRequest.Services[0].expirationDate !== '') &&
          (this.fwRequest.regionName !== '' || this.fwRequest.regionID !== '')) {
        return true;
      }
    } else if (this.getExistingAppliances || this.pId === '27102' || this.pId === '27104' || this.pId === '27121' && this.prodId !== '7' && this.prodId !== '-8' && this.prodId === '-21') {
      if (this.msspMonthyManaged.showOrganizationId) {
        if (this.fwRequest.Services[0].serviceId !== '' && this.fwRequest.Services[1].serviceId !== '' &&
          (!this.showExpiry || this.fwRequest.Services[0].expirationDate !== '') &&
          (this.fwProductObject.unitSelected === 'setUpperLimit' && this.fwRequest.Services[0].nodeCount !== '' &&
          (Number(this.fwRequest.Services[0].nodeCount) > this.minCount && Number(this.fwRequest.Services[0].nodeCount) < this.maxCount) ||
           this.fwProductObject.unitSelected === 'noUpperLimit') || !this.fwProductObject.ShowUpperLimit &&
          (!this.showChildExpiry || this.fwRequest.Services[1].expirationDate !== '') &&
          (this.fwProductObject.childUnitSelected === 'setUpperLimit' && this.fwRequest.Services[1].nodeCount !== '' &&
          (Number(this.fwRequest.Services[1].nodeCount) > this.childMinCount && Number(this.fwRequest.Services[1].nodeCount) < this.childMaxCount) ||
          this.fwProductObject.childUnitSelected === 'noUpperLimit') || !this.fwProductObject.ShowChildUpperLimit &&
          (this.fwRequest.regionName !== '' || this.fwRequest.regionID !== '')) {
          return true;
        }
      } else if (this.fwRequest.serialNumber !== '' &&
          this.fwRequest.Services[0].serviceId !== '' && this.fwRequest.Services[1].serviceId !== '' &&
          (!this.showExpiry || this.fwRequest.Services[0].expirationDate !== '') &&
          (!this.showChildExpiry || this.fwRequest.Services[1].expirationDate !== '') &&
          (!this.isDCApplies || this.fwRequest.regionName !== '' || this.fwRequest.regionID !== '')) {
        const sslVpnFlag = this.sslVpnObject.sslVpnToggle ? this.sslVpnObject.nodeCount > 0 && (Number(this.sslVpnObject.nodeCount) + Number(this.sslVpnObject.totalNodeCount)) <= Number(this.sslVpnObject.maxNodeCount) &&
        (this.sslVpnObject.expiryType === 'selectExpiry' && this.sslVpnObject.dateSelected !== '' || this.sslVpnObject.expiryType === 'Never') : true;
        return true && sslVpnFlag;
      }
    } else if (this.showUnits === 'YES') {
      if (!this.$v!.msspMonthyManaged!.nodeCount!.$invalid && !this.$v!.msspMonthyManaged!.serviceId!.$invalid &&
        (this.msspMonthyManaged.nodeCount != null && this.msspMonthyManaged.nodeCount !== '') &&
        (this.msspMonthyManaged.serviceId != null && this.msspMonthyManaged.serviceId !== '') &&
        ((this.msspMonthyManaged.showApplicationOption && !this.$v!.msspMonthyManaged!.applicationName!.$invalid &&
        this.msspMonthyManaged.applicationName !== null && this.msspMonthyManaged.applicationName !== '') || true) &&
        ((this.msspMonthyManaged.showSubDomainName && !this.$v!.msspMonthyManaged!.subDomain!.$invalid &&
        this.msspMonthyManaged.subDomain !== null && this.msspMonthyManaged.subDomain !== '') || true) &&
        ((this.expiryType === 'selectExpiry' && !this.$v!.msspMonthyManaged!.expiryDate!.$invalid &&
        this.msspMonthyManaged.expiryDate !== null && this.msspMonthyManaged.expiryDate !== '') || true)) {
        return true;
      }
    } else if (this.showUnits === 'NO') {
      if (!this.$v!.msspMonthyManaged!.serviceId!.$invalid &&
        (this.msspMonthyManaged.serviceId != null && this.msspMonthyManaged.serviceId !== '') &&
        ((this.msspMonthyManaged.showApplicationOption && !this.$v!.msspMonthyManaged!.applicationName!.$invalid &&
        this.msspMonthyManaged.applicationName !== null && this.msspMonthyManaged.applicationName !== '') || true) &&
        ((this.msspMonthyManaged.showSubDomainName && !this.$v!.msspMonthyManaged!.subDomain!.$invalid &&
        this.msspMonthyManaged.subDomain !== null && this.msspMonthyManaged.subDomain !== '') || true) &&
        ((this.expiryType === 'selectExpiry' && !this.$v!.msspMonthyManaged!.expiryDate!.$invalid &&
        this.msspMonthyManaged.expiryDate !== null && this.msspMonthyManaged.expiryDate !== '') || true)) {
        return true;
      }
    }
    return false;
  }

  fetchMsspProductSevices(tenantId: string, prodId: string) {
    const request = {
      tenantid: tenantId,
      serialNumber: this.serialNumber,
    };
    this.$store.dispatch('MswProductsStoreModule/getProductServicesList', request)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK' && response.msgCode === 'MSWAPP:GETMSSPPRODUCTSERVICEDETAILSSUCCESS') {
          this.serviceData = [];
          const result = response.content['ProductServices'];
          const regdProductServices: any = response.content['RegisteredProductServices'] || '';
          const licensing = response.content['ActiveLicenseingServices'] || '';
          this.isMdr = licensing !== '' ? true : false;
          const appSrvices: any = [];
          if (licensing !== '') {
            licensing.map((obj: any) => {
              const licensingTable: any = {
                _key: obj.ServiceName,
                serviceName: obj.ServiceName,
                expiryDate: obj.ExpiryDate,
              };
              appSrvices.push(licensingTable);
            });
          }
          this.serviceData = appSrvices;
          console.warn('msspFirewall', this.isMSSPFirewallProduct, this.isSecaasProduct);
          const prodID = (this.isMSSPFirewallProduct || this.isSecaasProduct) && prodId !== '27102' && prodId !== '27104' && prodId !== '27121' ? '-9' :
          prodId === '24105' || prodId === '24305' ? '-9' : prodId;
          result.map((prdServ:any) => prdServ['ProductFlavours'].map((flv:any) => {
            if (flv['ProductID'] === prodID || flv['ProductID'] === this.prodId ||
             prodID === '412' && flv['ProductID'] === '408' || (this.prodId === '-21' && flv['ProductID'] === '-8')) {
              this.serviceDetails = flv;
              this.platform = flv.Platform ? flv.Platform : '';
              this.productName = prdServ['ProductName'] || '';
              this.msspMonthyManaged.showSubDomainName = flv.ShowSubDomain === 'YES' ? true : false;
              this.disableServiceChange = flv.isServiceTypechangeAllowed && flv.isServiceTypechangeAllowed === 'YES' ? false : true;
              this.showUnits = flv.ShowUnits ? flv.ShowUnits : '';
              this.showHA = flv.ShowHA === 'YES' ? true : false;
              this.showUpperLimit = flv.ShowUpperLimit ? flv.ShowUpperLimit : '';
              this.msspMonthyManaged.showFriendlyName = flv.ShowFriendlyName ? flv.ShowFriendlyName : '';
              this.msspMonthyManaged.friendlyNameBaseText = flv.friendlyNameBaseText || '';
              this.msspMonthyManaged.showOrganizationId = flv?.ShowOganizationID === 'YES';
              if (this.msspMonthyManaged.showOrganizationId) {
                this.orgIdText = flv?.OganizationIDText || '';
                this.msspMonthyManaged.subDomain = flv?.OganizationIDValue || '';
                this.msspMonthyManaged.OganizationIDValue = flv?.OganizationIDValue || '';
              }
              this.getExistingAppliances = flv.getexistingAppliances === 'YES' ? true : false;
              if (flv.Regions) {
                flv.Regions.map((regionEle: ProductFlavourRegion) => {
                  this.regionOptions.push({
                    id: regionEle.RegionID,
                    label: regionEle.RegionName,
                    value: regionEle.RegionID,
                  });
                });
              }
            }
          }));
          if (response.content.isNewServiceEnrollAllowed && response.content.isNewServiceEnrollAllowed === 'YES') {
            this.msspMonthyManaged.serviceId = '';
          } else {
            this.msspMonthyManaged.serviceId = this.serviceDetails['Services'][0]['ServiceID'] || '';
          }
          this.showLicenceCheckbox = response.content['ShowLicAgr'] && response.content['ShowLicAgr'] === 'YES' ? true : false;
          this.showRegion = this.serviceDetails?.ShowRegion === 'YES';
          this.msspMonthyManaged.friendlyName = this.productDetails.friendlyName || '';
          if (regdProductServices !== '') {
            this.msspMonthyManaged.nodeCount =  regdProductServices[0]?.nodeCount;
            // this.msspMonthyManaged.unitSelected = regdProductServices[0]?.nodeCount === '0' ? 'noUpperLimit' : 'setUpperLimit';
            this.msspMonthyManaged.serviceId = regdProductServices[0]?.ServiceID;
            this.onServiceSelected(this.msspMonthyManaged.serviceId);
            if (regdProductServices[0]?.RegionID && regdProductServices[0]?.RegionID !== '') {
              this.msspMonthyManaged.regionId = regdProductServices[0]?.RegionID;
              this.msspMonthyManaged.regionName = regdProductServices[0]?.Region || '';
              this.disableRegionSelect = this.msspMonthyManaged.regionName !== '';
            }
            this.msspMonthyManaged.expiryDate = regdProductServices[0].ExpiryDate ? regdProductServices[0].ExpiryDate === 'Never' ? this.expiryType = 'Never' : regdProductServices[0].ExpiryDate : '';
          }
          if (this.getExistingAppliances || this.pId === '27102' || this.pId === '27104' || this.pId === '27121') {
            this.fwProductObject.firewall = this.serialNumber;
            const dataSent = {
              tenantId: this.groupId, productId: this.pId, serialNumber: this.serialNumber, isgetServiceDetails: true, mode: 'ENROLL',
            };
            this.getmsspAppliances(dataSent)
            .then(() => {
              this.fwRequest.ProductID = this.pId;
              this.fwRequest.serialNumber = this.serialNumber;
              this.msspMonthyManaged.showOrganizationId ? this.populateNsvServices() : this.onFirewallSelected();
            });

          }
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
        }
      })
      .catch((errResponse:any) => {
        console.error(errResponse);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: (this.$t('products.somethingWentWrong')
        .toString()) });
      });
  }
  formatDate(date: any) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const splitDate = date.split(' ');
    const month = String(monthNames.indexOf(splitDate[0]) + 1);
    console.warn('formatDate', (month)
    .concat('/', splitDate[1], '/', splitDate[2]));
    return month.length === 1 ? '0'.concat(month, '/', splitDate[1], '/', splitDate[2]) :
    month.concat('/', splitDate[1], '/', splitDate[2]);
  }
  showDivider() {
    return this.fwProductObject.firewall !== '' && this.fwProductObject.firewall !== 'register' && this.fwProductObject.childServiceName !== '' &&
    (this.showZt || this.isDCApplies || this.showMgmtOpt);
  }
  ztChange() {
    this.fwRequest.isZT = this.fwProductObject.showZt ? 'YES' : 'NO';
    this.onClickAccept();
  }
  onChangeTzExpiry() {
    // this.updateProductState();
    this.fwProductObject.dateSelected = this.fwProductObject.expiryType === 'Never' ? '' : this.dateSelected;
    this.fwRequest.Services[0].expirationDate = this.fwProductObject.dateSelected === '' && this.fwProductObject.expiryType === 'Never' ? 'Never' : this.fwProductObject.dateSelected;
    this.onClickAccept();
  }
  onChangeChildExpiry() {
    this.fwProductObject.childDateSelected = this.fwProductObject.childExpiryType === 'Never' ? '' : this.childDateSelected;
    this.fwRequest.Services[1].expirationDate = this.fwProductObject.childDateSelected === '' && this.fwProductObject.childExpiryType === 'Never' ? 'Never' : this.fwProductObject.childDateSelected;
    this.onClickAccept();
  }
  onClickAccept() {
    this.fwRequest.Services[0].expirationDate = this.fwProductObject.expiryType === 'Never' ? 'Never' : this.fwProductObject.dateSelected;
    this.fwRequest.Services[1].expirationDate = this.isGen8 ? this.fwProductObject.dateSelected :
     this.fwProductObject.childExpiryType === 'Never' ? 'Never' : this.fwProductObject.childDateSelected;
    // this.onClickAccept();
    // this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: this.acceptProvision });
    // console.warn('tzmodal', this.acceptProvision);
    // this.$emit('onAgree', this.fwRequest);
  }
  onRegionSelected() {
    const regionName = this.regionOptions.filter((ele: SelectOption) =>  ele.id === this.fwProductObject.regionSelected);
    this.fwProductObject.regionName = regionName[0] ? regionName[0].label.toString() : '';
    // this.updateProductState();
    this.onClickAccept();
  }

  onFirewallSelected() {
    if (this.fwProductObject.firewall === 'register') {
      window.open('/workspace/m/feature/register-products');
    } else {
      const sNum = (this.msspAppliances.serialList.filter((obj:any) => obj.serialNumber.toString()
      .toUpperCase() === (this.fwProductObject.firewall.toString()
      .toUpperCase())))[0];
      this.fwRequest.ProductID = sNum.productId;
      this.fwRequest.serialNumber = sNum.serialNumber;
      this.fwRequest.isZT = this.fwProductObject.showZt ? 'YES' : 'NO';
      this.fwRequest.friendlyName = sNum.friendlyName;
      this.isGen8 = sNum.productChoiceId === '-6';
      this.acceptProvision = false;
      this.onClickAccept();
      this.populateService();
      // const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      console.warn('fire', this.fwProductObject.firewall);
    }
  }
  populateService() {
    const fw = (this.msspAppliances.serialList.filter((obj:any) => obj.serialNumber.toString()
    .toUpperCase() === (this.fwProductObject.firewall.toString()
    .toUpperCase())))[0];
    this.fwProductObject.showApplicationOption = false;
    this.showAgree = fw.ShowLicAgr === 'YES' ? true : false;
    this.manageOptions = [];
    this.msspAppliances.FirewallManagementoptiondetails.firewallmgnoptions.map((mnge: any) => {
      this.manageOptions.push({
        id: mnge.optionname,
        label: mnge.optionname,
        value: mnge.optionname,
      });
      this.fwProductObject.manage = mnge.currentOption === 1 ? mnge.optionname : this.fwProductObject.manage;
    });
    if (this.msspAppliances.hasOwnProperty('provisionserviceOptions')) {
      const obj = this.msspAppliances.provisionserviceOptions[0] || null;
      if (obj && obj !== null) {
        const obj = this.msspAppliances.provisionserviceOptions[0] || {};
        if (obj.productId === (fw.productId)) {
          this.tzserviceOptions = [];
          this.serviceLabel = obj.serviceNameDisplay;
          obj.serviceOptions.map((ele:any) => {
            // console.warn('ele', ele.serviceId, ele.serviceName);
            this.tzserviceOptions.push({
              id: ele.serviceId.toString(),
              label: ele.serviceName,
              value: ele.serviceName,
            });
            if (ele.isselected === 'YES') {
              this.fwProductObject.serviceName = ele.isselected === 'YES' ? ele.serviceId.toString() : this.fwProductObject.serviceName;
              this.showExpiry = ele.showExpDate === 'YES' ? true :false;
              this.fwProductObject.expiryType = ele.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
              this.fwProductObject.dateSelected = ele.expDate === 'Never' ||  ele.isExpiryNever === 'YES' ? '' : ele.expDate;
              this.infoIconText = ele?.infoIconText ? ele?.infoIconText : '';
            }
          });
        }
        const sslVpnObj = this.msspAppliances?.provisionserviceOptions[1] || null;
        if (sslVpnObj !== null) {
          this.sslServiceLabel = sslVpnObj.serviceNameDisplay;
          // console.warn(this.msspAppliances.provisionserviceOptions[1]['serviceOptions']);
          const sslVpnService =  sslVpnObj.serviceOptions[0] ;
          this.sslVpnObject = {
            serviceId: sslVpnService.serviceId,
            showExpiry: sslVpnService.showExpDate === 'YES' ? true :false,
            showNodeCount: sslVpnService.showNodeCount === 'YES' ? true :false,
            sslVpnToggle: sslVpnService.isselected === 'YES' ? true : false,
            nodeCount: sslVpnService.nodeCount || '0',
            totalNodeCount: sslVpnService.defaultNodecount || '0',
            maxNodeCount: String(sslVpnService.maxNodeCount),
            expiryType: sslVpnService.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry',
            dateSelected: sslVpnService.expDate === 'Never' ||  sslVpnService.isExpiryNever === 'YES' ? '' : sslVpnService.expDate,
            tooltip: sslVpnService.tooltip,
          };
        }
      }
    }
    // this.showZt = fw.showZeroTouch === 'YES' ? true : false;
    // this.fwProductObject.showZt = fw.ztValue === 1 ? true : false;
    fw.currentServiceList.map((obj:any) => {
      this.currentServices = obj.serviceGroupDisplayName;
      // if (obj.hasOwnProperty('applicableServices')) {
      //   console.warn('app', obj.applicableServices);
      //   this.applicableServices = obj.applicableServices;
      //   obj.applicableServices.map((ele:any) => {
      //     console.warn(ele.serviceId, 'sars');
      //     this.serviceOptions.map((item:any) => {
      //       console.warn(item.id, ele.serviceId, ele.serviceName, this.serviceLabel, this.childServiceLabel, 'sar');
      //       if (ele.hasOwnProperty('serviceId') && item.id === (ele.serviceId.toString())) {
      //         this.fwProductObject.serviceName = item.id;
      //         this.showExpiry = true;
      //         this.fwProductObject.expiryType = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? 'Never' : 'selectExpiry';
      //         this.fwProductObject.dateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' : this.formatDate(ele.expDate.trim());
      //         this.dateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' :this.formatDate(ele.expDate.trim());
      //       } else if (!ele.hasOwnProperty('serviceId') && ele.serviceName === this.serviceLabel) {
      //         this.fwProductObject.serviceName = '-1';
      //         this.showExpiry = item.showExpDate;
  //       }
  //     });
  //   });
      this.onTzServiceSelected();
  // }
      if (this.msspAppliances.hasOwnProperty('arrDcList') && !this.msspAppliances.hasOwnProperty('dcName')) {
        this.regionOptions = [];
        this.msspAppliances.arrDcList.map((list: any) => {
          this.regionOptions.push({
            id: list.dcId.toString(),
            label: list.description,
            value: list.name,
          });
        });
      }
    });
    const appSrvices: any = [];
    this.applicableServices.map((obj: any) => {
      const serviceObj: any = {
        _key: obj.serviceName,
        serviceName: obj.serviceName,
        expiryDate: obj.expDate,
      };
      appSrvices.push(serviceObj);
    });
    this.serviceData = appSrvices;
    this.$store.commit('stopLoading');
  }
  populateNsvServices() {
    this.fwProductObject.showApplicationOption = false;
    // this.showAgree = true;
    // this.acceptProvision = !this.showAgree ? true : false;
    this.manageOptions = [];
    this.msspAppliances.FirewallManagementoptiondetails.firewallmgnoptions.map((mnge: any) => {
      this.manageOptions.push({
        id: mnge.optionname,
        label: mnge.optionname,
        value: mnge.optionname,
      });
      this.fwProductObject.manage = mnge.currentOption === 1 ? mnge.optionname : this.fwProductObject.manage;
    });
    if (this.msspAppliances.hasOwnProperty('provisionserviceOptions')) {
      const obj = this.msspAppliances.provisionserviceOptions[0] || {};
      this.tzserviceOptions = [];
      this.serviceLabel = obj.serviceNameDisplay;
      obj.serviceOptions.map((ele:any) => {
        // console.warn('ele', ele.serviceId, ele.serviceName);
        this.tzserviceOptions.push({
          id: ele.serviceId.toString(),
          label: ele.serviceName,
          value: ele.serviceName,
        });
        if (ele.isselected === 'YES') {
          this.fwProductObject.serviceName = ele.isselected === 'YES' ? ele.serviceId.toString() : this.fwProductObject.serviceName;
          this.showExpiry = ele.showExpDate === 'YES' ? true :false;
          this.fwProductObject.expiryType = ele.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
          this.fwProductObject.dateSelected = ele.expDate === 'Never' ||  ele.isExpiryNever === 'YES' ? '' : ele.expDate;
        }
      });
      const sslVpnObj = this.msspAppliances?.provisionserviceOptions[1] || null;
      if (sslVpnObj !== null) {
        this.sslServiceLabel = sslVpnObj.serviceNameDisplay;
        // console.warn(this.msspAppliances.provisionserviceOptions[1]['serviceOptions']);
        const sslVpnService =  sslVpnObj.serviceOptions[0] ;
        this.sslVpnObject = {
          serviceId: sslVpnService.serviceId,
          showExpiry: sslVpnService.showExpDate === 'YES' ? true :false,
          showNodeCount: sslVpnService.showNodeCount === 'YES' ? true :false,
          sslVpnToggle: sslVpnService.isselected === 'YES' ? true : false,
          nodeCount: sslVpnService.nodeCount || '0',
          totalNodeCount: sslVpnService.defaultNodecount || '0',
          maxNodeCount: String(sslVpnService.maxNodeCount),
          expiryType: sslVpnService.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry',
          dateSelected: sslVpnService.expDate === 'Never' ||  sslVpnService.isExpiryNever === 'YES' ? '' : sslVpnService.expDate,
          tooltip: sslVpnService.tooltip,
        };
      }
    }
    this.onTzServiceSelected();
    if (this.msspAppliances.hasOwnProperty('arrDcList') && !this.msspAppliances.hasOwnProperty('dcName')) {
      this.regionOptions = [];
      this.msspAppliances.arrDcList.map((list: any) => {
        this.regionOptions.push({
          id: list.dcId.toString(),
          label: list.description,
          value: list.name,
        });
      });
    }
    const appSrvices: any = [];
    this.applicableServices.map((obj: any) => {
      const serviceObj: any = {
        _key: obj.serviceName,
        serviceName: obj.serviceName,
        expiryDate: obj.expDate,
      };
      appSrvices.push(serviceObj);
    });
    this.serviceData = appSrvices;
    this.onClickAccept();
  }
  resetValues() {
    this.fwProductObject.productName = '';
    this.fwProductObject.serviceName = '';
  }

  // get getProductNewModalObject() {
  //   return this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
  // }

  // get getDisabledStateForProduct() {
  //   const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
  //   const msspName = productDetailsFromStore.msspName;
  //   const tenantName = productDetailsFromStore.tenantName;
  //   if ((msspName !== '' &&  tenantName !== '')) {
  //     // this.loadAnotherProductApi();
  //   }
  //   return !(msspName !== '' &&  tenantName !== '');
  // }

  onTzServiceSelected() {
    // let disAbled: boolean = false;
    // let tooltipVal: string = '';
    // const fw = (this.msspAppliances.serialList.filter((obj:any) => obj.serialNumber === (this.fwProductObject.firewall)))[0];
    this.msspAppliances.provisionserviceOptions.map((serv: any) => {
      // const ifServiceNOtChanged = ((fw.currentServiceList[0].applicableServices[0].serviceName.toLowerCase()).includes(this.serviceLabel.toLowerCase())) &&
      //   (fw.currentServiceList[0].applicableServices[1].serviceName.toLowerCase()).includes(this.serviceLabel.toLowerCase());
      // const noChange = serv.serviceOptions.filter((obj:any) => obj.serviceId === -1)[0];
      serv.serviceOptions.map((obj:any) => {
        if (obj.serviceId === Number(this.fwProductObject.serviceName)) {
          this.selectedService = obj ;
          this.showExpiry = obj.showExpDate === 'YES' ? true : false;
          this.childServiceOptions = [];
          this.fwProductObject.ShowUpperLimit = obj.ShowUpperLimit === 'YES' || obj.ShowUpperLimit === 'NOCAP';
          this.serviceShowUpperLimit = obj.ShowUpperLimit;
          this.fwProductObject.unitSelected = obj.ShowUpperLimit === 'NOCAP' || obj?.nodeCount === '99999' || obj?.nodeCount === '99998' ||
          obj?.nodeCount === 'No upper limit' ? 'noUpperLimit' : 'setUpperLimit';
          this.infoIconText = obj?.infoIconText ? obj?.infoIconText : '';
          this.fwProductObject.upperLimit = this.fwProductObject.unitSelected === 'noUpperLimit' ? '99999' :
           obj.nodeCount === undefined ? '' : obj.nodeCount;
          this.minCount = obj?.minNodeCount || 0;
          this.maxCount = obj?.maxNodeCount || 0;
          this.isReadOnly = false;
          obj.childOptions.map((ele: any) => {
            this.childServiceLabel = ele.childserviceNameDisp;
            console.warn('childele', ele);
            if (this.childServiceLabel !== '') {
              ele.childServiceOptions.map((childEle: any) => {
                this.childServiceOptions.push({
                  id: childEle.serviceId.toString(),
                  label: childEle.serviceName,
                  value: childEle.serviceName,
                });
                if (childEle.isselected === 'YES') {
                  this.fwProductObject.childServiceName = childEle.isselected === 'YES' ? childEle.serviceId.toString() : this.fwProductObject.childServiceName;
                  this.appShowZt = childEle.showZeroTouch === 'YES' ? true : false;
                  this.ztValue = childEle.ztValue === 1 ? true : false;
                  this.showChildExpiry = childEle.showExpDate === 'YES' ? true : false;
                  this.fwProductObject.childExpiryType =  childEle.isExpiryNever === 'YES' ? 'Never' : 'selectExpiry';
                  this.fwProductObject.childDateSelected = childEle.expDate === 'Never' ? '' : childEle.expDate;
                  this.fwProductObject.ShowChildUpperLimit = childEle.ShowUpperLimit === 'YES' || childEle.ShowUpperLimit === 'NOCAP';
                  this.childShowUpperLimit = childEle.ShowUpperLimit;
                  this.fwProductObject.childUnitSelected = childEle.ShowUpperLimit === 'NOCAP' || childEle?.nodeCount === '99999' || childEle?.nodeCount === '99998' ||
                  childEle?.nodeCount === 'No upper limit' ? 'noUpperLimit' : 'setUpperLimit';
                  this.fwProductObject.childUpperLimit = this.fwProductObject.childUnitSelected === 'noUpperLimit' ? '99999' :
                  childEle?.nodeCount === undefined ? '' : childEle?.nodeCount;
                  this.childMinCount = childEle?.minNodeCount || 0;
                  this.childMaxCount = childEle?.maxNodeCount || 0;
                  this.isDisabled = childEle.isDisabled === 'YES' ? true : false;
                  this.serviceTooltip = childEle.tooltip !== '' ? childEle.tooltip : '';
                  this.isReadOnly = childEle.isReadOnly === 'YES' ? true : false;
                }
              });
            }
          });
        } /* else if (ifServiceNOtChanged) {
          this.selectedService = noChange ;
          this.showExpiry = noChange.showExpDate === 'YES' ? true : false;
          this.childServiceOptions = [];
          noChange.childOptions.map((ele: any) => {
            this.childServiceLabel = ele.childserviceNameDisp;
            console.warn('childele', ele);
            ele.childServiceOptions.map((childEle: any) => {
              if (childEle.serviceId === 46465) {
                disAbled = childEle.isDisabled === 'YES' ? true : false;
                tooltipVal = childEle.tooltip !== '' ? childEle.tooltip : '';
              }
              this.childServiceOptions.push({
                id: childEle.serviceId.toString(),
                label: childEle.serviceName,
                value: childEle.serviceName,
              });
            });
          });
        } */
      });
    });
    // console.warn('fw', fw);
    // fw.currentServiceList.map((obj:any) => {
      // if (obj.hasOwnProperty('applicableServices')) {
      //   obj.applicableServices.map((ele:any) => {
      //     this.childServiceOptions.map((item:any) => {
      //       console.warn('hilserv', ele.serviceId, item.id);
      //       if ((ele.serviceName.toLowerCase()).includes(this.childServiceLabel.toLowerCase()) || ele.hasOwnProperty('serviceId') && (item.id ===  ele.serviceId.toString())) {
      //         console.warn('rec', item.id, this.fwProductObject.childExpiryType);
      //         this.fwProductObject.childServiceName = (ele.serviceName.toLowerCase()).includes(this.childServiceLabel.toLowerCase()) || !val ? '' : item.id;
      //         this.appShowZt = ele.showZeroTouch === 'YES' ? true : false;
      //         this.ztValue = ele.ztValue === 1 ? true : false;
      //         if (val || (ele.serviceName.toLowerCase()).includes(this.childServiceLabel.toLowerCase())) {
      //           this.showChildExpiry = this.fwProductObject.childServiceName !== '' ? true : false;
      //           this.fwProductObject.childExpiryType = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? 'Never' : 'selectExpiry';
      //           console.warn('expchild', this.fwProductObject.ChildExpiryType, ele.expDate);
      //           this.fwProductObject.childDateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' : this.formatDate(ele.expDate.trim());
      //           this.childDateSelected = ele.expDate === 'Never' || ele.expDate === 'Unlicensed' ? '' : this.formatDate(ele.expDate.trim());
      //         } else {
      //           this.showChildExpiry = false;
      //           // this.fwProductObject.childExpiryType = 'Never';
      //           // this.fwProductObject.childDateSelected =  '';
      //           // this.appShowZt = false;
      //           // this.ztValue = false;
  //         }
  //       }
  //     });
  //   });
  // }
    // });
    console.warn('chid', this.fwProductObject.serviceName);
    // if (this.fwProductObject.serviceName === '7223') {
    //   this.isDisabled = true;
    //   this.fwProductObject.childServiceName = '46465';
    //   this.serviceTooltip = tooltipVal;
    // } else if (disAbled && this.fwProductObject.childServiceName !== '') {
    //   this.isDisabled = true;
    //   this.serviceTooltip = tooltipVal;
    // } else {
    //   this.isDisabled = false;
    //   this.serviceTooltip = '';
    // }
    this.fwRequest.Services[0].serviceId = this.fwProductObject.serviceName;
    this.fwRequest.Services[0].expirationDate = this.fwProductObject.dateSelected === '' || !this.showExpiry ? 'Never' : (this.fwProductObject.dateSelected);
    this.fwRequest.Services[0].nodeCount = this.fwProductObject.ShowUpperLimit ? this.fwProductObject.upperLimit : '1';
    if (this.childServiceLabel !== '') {
      this.onChildServiceSelected();
    }
    this.onClickAccept();
  }
  onChildServiceSelected() {
    if (this.fwProductObject.serviceName !== '') {
      this.selectedService.childOptions.map((obj:any) => {
        obj.childServiceOptions.map((ele:any) => {
          console.warn('objChild', ele.serviceId , this.fwProductObject.childServiceName);
          if (ele.serviceId === Number(this.fwProductObject.childServiceName)) {
            this.showChildExpiry = ele.showExpDate === 'YES' ? true : false;
            this.isDisabled = ele.isDisabled === 'YES' ? true : false;
            this.serviceTooltip = ele.tooltip !== '' ? ele.tooltip : '';
            this.fwProductObject.ShowChildUpperLimit = ele.ShowUpperLimit === 'YES' || ele.ShowUpperLimit === 'NOCAP';
            this.childShowUpperLimit = ele.ShowUpperLimit;
            this.fwProductObject.childUnitSelected = ele.ShowUpperLimit === 'NOCAP' || ele?.nodeCount === '99999' || ele?.nodeCount === '99998' ||
            ele?.nodeCount === 'No upper limit' ? 'noUpperLimit' : 'setUpperLimit';
            this.fwProductObject.childUpperLimit = this.fwProductObject.childUnitSelected === 'noUpperLimit' ? '99999' :
                ele?.nodeCount === undefined ? '' : ele?.nodeCount;
            this.childMinCount = ele?.minNodeCount || 0;
            this.childMaxCount = ele?.maxNodeCount || 0;
            this.showZt = ele.showZeroTouch === 'YES' ? true : false;
            this.ztValue = ele.ztValue === 1 ? true : false;
            this.fwProductObject.showZt = ele.isZTApplicable === 'YES' ? this.ztValue : false;
            this.isDCApplies = ele.isDCApplies === 'YES' ? true : false;
            this.showMgmtOpt = ele.showMgmtOpt === 'YES' ? true : false;
            this.isReadOnly = ele.isReadOnly === 'YES' ? true : false;
            this.ztChange();
          }
        });
      });
    }
    this.fwRequest.Services[1].expirationDate = this.isGen8 ? this.fwProductObject.dateSelected :
     (this.fwProductObject.childDateSelected === '' && this.fwProductObject.childExpiryType === 'Never') || !this.showChildExpiry ? 'Never' : this.fwProductObject.childDateSelected;
    this.fwRequest.Services[1].serviceId = this.isDisabled && !this.isReadOnly ? '' : this.fwProductObject.childServiceName;
    this.fwRequest.Services[1].nodeCount = this.fwProductObject.ShowChildUpperLimit ? this.fwProductObject.childUpperLimit : '1';
    console.warn(this.fwRequest, 'request');
    this.onClickAccept();
  }
  get applicableColumnConfig(): TableColumnConfig[] {
    return [{
      key: 'serviceName',
      dataKey: 'serviceName',
      title: this.currentServices || 'Active Annual Licensing',
      tooltip: { content: this.currentServices, compact: true  },
      width: 230,
    }, {
      key: 'expiryDate',
      dataKey: 'expiryDate',
      title: 'Expiration Date',
      width: 120,
    }];
  }
  getmsspAppliances(data: any) {
    return new Promise((res, rej) => {
      this.$store.commit('startLoading');
      this.$store.dispatch('MswProductsStoreModule/getMsspAppliances', data)
      .then((resp: any) => {
        this.getShowErrMsg = false;
        this.msspAppliances = resp.content;
        this.showDc = this.msspAppliances.showDC === 'YES' ? true : false;
        this.fwProductObject.dcName = this.msspAppliances.dcName ? this.msspAppliances.dcName : '';
        this.fwRequest.regionName = this.fwProductObject.dcName;
        this.applianceText = this.msspAppliances?.applianceText || '';
        if (this.msspAppliances.hasOwnProperty('serialList') && this.fwProductObject.firewall === '') {
          this.firewallOptions = [];
          if (this.msspAppliances.showRegisterNewProduct === 'YES') {
            this.firewallOptions.push({
              id: 'register',
              label: this.msspAppliances.showRegisterNewProductLabel,
              value: 'register',
            });
          }
          this.msspAppliances.serialList.map((obj:any) => {
            this.firewallOptions.push({
              id: obj.serialNumber,
              label: obj.serialNumber.concat(' - ' , obj.friendlyName),
              value: obj.productId,
            });
          });
        } else {
          if (this.msspAppliances.showRegisterNewProduct === 'YES' && this.firewallOptions.length <= 1) {
            this.firewallOptions = [];
            this.firewallOptions.push({
              id: 'register',
              label: this.msspAppliances.showRegisterNewProductLabel,
              value: 'register',
            });
          }
          const fw = (this.msspAppliances.serialList.filter((obj:any) => obj.serialNumber.toString()
          .toUpperCase() === (this.fwProductObject.firewall.toString()
          .toUpperCase())))[0];
          fw.currentServiceList.map((obj:any) => {
            this.currentServices = obj.serviceGroupDisplayName;
            if (obj.hasOwnProperty('applicableServices')) {
              console.warn('app', obj.applicableServices);
              this.applicableServices = obj.applicableServices;
            }
          });
          this.$store.commit('stopLoading');
          res(true);
        }
      })
      .catch(() => {
        rej(true);
        this.$store.commit('stopLoading');
      });
    });
  }
  updateProductState() {
    this.fwRequest.isHA = this.isHA ? 'YES' : 'NO';
  }
  created() {
    this.fetchMsspProductSevices(this.groupId, this.pId);
  }

  onServiceSelected(val:any) {
    this.msspMonthyManaged.showApplicationOption = false;
    this.applicationOption = [];
    this.serviceDetails.Services.forEach((ser:any) => {
      if (ser.ServiceID === val && ser.casbAppList) {
        this.msspMonthyManaged.showApplicationOption = true;
        ser.casbAppList.map((appEle: CasbAppList) => {
          this.applicationOption.push({
            id: appEle.appValue,
            label: appEle.appName,
            value: appEle.appValue,
          });
        });
      }
    });
  }

  onPencilCick() {
    this.editFriendName = true;
    this.fName = this.msspMonthyManaged.friendlyName;
  }
  onTickClick() {
    if (this.msspMonthyManaged.friendlyName.trim().length > 0) {
      this.renameProduct(this.msspMonthyManaged.friendlyName);
      this.editFriendName = false;
      // this.editFriendlyName(data, false);
    }
  }
  onCrossClick() {
    this.editFriendName = false;
    this.msspMonthyManaged.friendlyName = this.fName;
    // this.editFriendlyName(data, false);
  }

  renameProduct(data: any) {
    this.$store.commit('startLoading');
    const renamelist = [{ serialNumber: this.serialNumber, newName: data }];
    this.$store.dispatch(
      'MswProductsStoreModule/renameFriendlyName', { prodsRenamelist: renamelist },
    )
    .then((res) => {
      if (res.msgCode === 'MSWAPP:PRODSRENAMESUCCESS') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else if (res.msgCode === 'MSWAPP:PRODSRENAMEFAILURE') {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.msspMonthyManaged.friendlyName = this.fName;
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: String(this.$t('tenantMgmt.provision.messages.renameFail')) };
        this.$store.commit('enqueueMessage', message);
        this.msspMonthyManaged.friendlyName = this.fName;
      }
      this.$store.commit('stopLoading');
    });
  }

  makeElipsis(item: string, size:number = 20) {
    if (item.length > size) {
      return `${item.slice(0, size)}...`;
    } return item;
  }
}
